import { render, staticRenderFns } from "./apply-detail.vue?vue&type=template&id=4aff1576&scoped=true"
import script from "./apply-detail.vue?vue&type=script&lang=js"
export * from "./apply-detail.vue?vue&type=script&lang=js"
import style0 from "./apply-detail.vue?vue&type=style&index=0&id=4aff1576&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff1576",
  null
  
)

export default component.exports